import {
  Box,
  Button,
  FormLabel,
  Heading,
  Input,
  Spinner,
  Text,
  VStack,
} from "@chakra-ui/react";
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useSearchParams } from "react-router-dom";
import { InvoiceDetails, supplyInvoiceInfo } from "../../Api/api2";
import { ofiEmail } from "../foreningen";

export function VerifySignup() {
  const [searchParams] = useSearchParams();
  const contractId = searchParams.get("ID");

  const [name, setName] = useState<string | undefined>(undefined);
  const [orgNr, setOrgNr] = useState<string | undefined>(undefined);
  const [email, setEmail] = useState<string | undefined>(undefined);
  const [address, setAddress] = useState<string | undefined>(undefined);
  const [phoneNumber, setPhoneNumber] = useState<string | undefined>(undefined);
  const [validForm, setValidForm] = useState(false);

  const [submitStatus, setSubmitStatus] = useState(SubmitStatus.NOTSUBMITTED);

  useEffect(() => {
    const nameValid = name !== undefined && name !== "";
    const emailValid = email !== undefined && email !== "";
    const addressValid = address !== undefined && address !== "";
    setValidForm(nameValid && emailValid && addressValid);
  }, [name, email, address]);

  const form = useForm<InvoiceDetails>({
    defaultValues: {},
  });

  const handleSubmit = () => {
    setSubmitStatus(SubmitStatus.WAITING);
    supplyInvoiceInfo(contractId ?? "", {
      invoicePayerName: name ?? "",
      organizationNumber: orgNr ?? "",
      invoiceAddress: address ?? "",
      invoiceEmail: email ?? "",
      invoicePhone: phoneNumber ?? "",
    })
      .then((reply) => {
        if (reply.status >= 200 && reply.status < 300) {
          setSubmitStatus(SubmitStatus.ACCEPTED);
        } else {
          setSubmitStatus(SubmitStatus.NOTACCEPTED);
        }
      })
      .catch(() => {
        setSubmitStatus(SubmitStatus.NOTACCEPTED);
      });
    /*
    setName(undefined);
    setEmail(undefined);
    setAddress(undefined);
    setPhoneNumber(undefined);
    */
  };

  if (submitStatus === SubmitStatus.ACCEPTED) {
    return (
      <>
        <Heading size="lg" mb={4}>
          Tack!
        </Heading>
        <Text marginBottom={"10px"}>Vi har tagit emot dina uppgifter.</Text>
        <Text marginBottom={"30px"}>
          Ett bekräftelsemail ska nu ha skickats till dig. Fakturan dyker upp så
          fort vi har hanterat den.{" "}
        </Text>
      </>
    );
  }

  return (
    <>
      <Heading size="lg" mb={4}>
        Slutför din anmälan
      </Heading>
      <Text marginBottom={"30px"}>
        För att slutföra anmälan måste du skicka in nedanstående
        faktureringsuppgifter. Faktureringen hanteras manuellt och kan därför ta
        lite tid innan den dyker upp.
      </Text>
      <form
        onSubmit={(r) => {
          r.preventDefault();
        }}
      >
        <Heading size="md" mb={4}>
          Fakturerings information
        </Heading>

        <VStack spacing={4} align="stretch">
          <FormLabel htmlFor="invoiceName">Namn</FormLabel>
          <Input
            id="invoiceName"
            placeholder="Klubbens namn"
            type="text"
            onChange={(e) => {
              setName(e.target.value);
            }}
            width={"md"}
          />
          <FormLabel htmlFor="invoiceOrgNr">Organisationsnummer</FormLabel>
          <Input
            id="invoiceOrgNr"
            placeholder="org.nr"
            type="text"
            onChange={(e) => {
              setOrgNr(e.target.value);
            }}
            width={"md"}
          />
          <FormLabel htmlFor="invoiceAddress">Adress</FormLabel>
          <Input
            id="invoiceAddress"
            placeholder="Postadress"
            onChange={(e) => {
              setAddress(e.target.value);
            }}
            type="text"
            width={"md"}
          />
          <FormLabel htmlFor="invoiceEmail">Email</FormLabel>
          <Input
            id="invoiceEmail"
            placeholder="Email adress "
            onChange={(e) => {
              setEmail(e.target.value);
            }}
            type="email"
            width={"md"}
          />
          <FormLabel htmlFor="invoiceTelefon">Telefon</FormLabel>
          <Input
            id="invoiceTelefon"
            placeholder="Telefon nummer"
            onChange={(e) => {
              setPhoneNumber(e.target.value);
            }}
            type="number"
            width={"md"}
          />
          <Button
            variant="solid"
            background={validForm ? "blue.300" : undefined}
            mr={3}
            type="button"
            width={"sm"}
            leftIcon={
              submitStatus === SubmitStatus.WAITING ? <Spinner /> : undefined
            }
            onClick={() => {
              if (validForm && submitStatus !== SubmitStatus.WAITING) {
                handleSubmit();
              }
            }}
          >
            {submitStatus === SubmitStatus.WAITING ? "Skickar..." : "Skicka"}
          </Button>
        </VStack>
        <Box
          key={"team"}
          border="1px"
          background={"red.200"}
          borderColor="gray.300"
          hidden={submitStatus !== SubmitStatus.NOTACCEPTED}
          p={4}
          rounded="xl"
          margin={"20px"}
        >
          <VStack>
            <Text color={"red"} as="b">
              Något gick fel. Kontrolera dina uppgifter och försök igen!
            </Text>
            <Text color={"red"} as="b">
              Om felet kvarstår kan du kontakta oss via {ofiEmail}, beskriv
              felet och ange contractId: {contractId}
            </Text>
          </VStack>
        </Box>
      </form>

      {/*
        <VStack spacing={4} align="stretch">
          {participants.fields.map((field, index) => {
            return (
              <Box
                key={field.id}
                border="1px"
                borderColor="gray.300"
                p={4}
                rounded="xl"
              >
                <Heading size="sm" mb={2}>
                  Deltagare {index + 1}
                </Heading>
                <Controller
                  control={form.control}
                  name={`participants.${index}.firstName}`}
                  rules={{
                    required: {
                      value: true,
                      message: "Saknar förnamn",
                    },
                  }}
                  render={({ field, fieldState }) => {
                    return (
                      <FormControl
                        isInvalid={fieldState.error !== undefined}
                        mb={4}
                      >
                        <FormLabel htmlFor="firstName">Förnamn</FormLabel>
                        <Input id="firstName" type="text" {...field} />
                        {fieldState.error !== undefined && (
                          <FormErrorMessage>
                            {fieldState.error.message}
                          </FormErrorMessage>
                        )}
                      </FormControl>
                    );
                  }}
                />

                <Controller
                  control={form.control}
                  name={`participants.${index}.yearOfBirth`}
                  rules={{
                    required: {
                      value: true,
                      message: "Saknar födelseår",
                    },
                  }}
                  render={({ field: { value, ...field }, fieldState }) => {
                    return (
                      <FormControl isInvalid={fieldState.error !== undefined}>
                        <FormLabel htmlFor="yearOfBirth">Födelseår</FormLabel>
                        <Select
                          id="yearOfBirth"
                          {...field}
                          value={null ? "" : value + ""}
                        >
                          <option value="">Välj födelseår</option>
                          {Array.from({
                            length:
                              (eventItem.maxAge ?? 99) -
                              (eventItem.minAge ?? 1) +
                              1,
                          }).map((_, index) => {
                            const year = new Date().getFullYear();
                            const yearOfBirth =
                              year - (eventItem.minAge ?? 1) - index;
                            return (
                              <option key={yearOfBirth} value={yearOfBirth}>
                                {yearOfBirth}
                              </option>
                            );
                          })}
                        </Select>
                        {fieldState.error !== undefined && (
                          <FormErrorMessage>
                            {fieldState.error.message}
                          </FormErrorMessage>
                        )}
                      </FormControl>
                    );
                  }}
                />
              </Box>
            );
          })}
        </VStack>
      </form>
*/}
    </>
  );
}

enum SubmitStatus {
  NOTSUBMITTED,
  WAITING,
  ACCEPTED,
  NOTACCEPTED,
}
